import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  postHostedSession: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide/slide-types/hosted-sessions`,
  },
  getUsage: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/slide-types/usage/{slideTypeKey}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const postHostedSession = async (presentationId, slideTypes) => {
  const res = await resource.postHostedSession({}, { presentationId, slideTypes })
  if (!res.ok) throw Object.assign(new Error(`HTTP ${res.status}`), { response: res })
}

// Resolves to 0 while the endpoint does not exist yet (404).
const getHostedSessionCount = async (slideTypeKey) => {
  try {
    const res = await resource.getUsage({ slideTypeKey })
    return Number(res.body?.hostedSessions) || 0
  } catch (error) {
    if (error?.status === 404 || error?.response?.status === 404) return 0
    throw error
  }
}

export default { initResource, postHostedSession, getHostedSessionCount }
